import React, {Component} from 'react'

export default class StripeFailure extends Component
{

	render()
	{
		return (
			<div style={{margin:"5px", padding:"5px", border:"1px solid red"}}>
				Sorry, your payment wasn't successful.<br />
				<input type="button" value="OK" onClick={e => this.props.parent.home() } />
			</div>
		);
	} // render

} ////
